module.exports = __webpack_public_path__ + "media/mem_chiar.c1e58fe6.mp4";